var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column list"},[(_vm.type==="music")?_c('video',{staticClass:"video",attrs:{"src":_vm.path,"controls":"","width":"100%"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }